import React, { Fragment, useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ContentApp from '../../../components/ContentApp';
import { fetchReservation } from '../../../helpers/reservation';
import { WelletContext } from '../../../context/WelletContext';
import { getQueryString } from '../../../helpers/url';
import useForm from '../../../helpers/useForm';
import ButtonProccessing, {
  ButtonStatus,
} from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import { isValidPhoneNumber } from 'react-phone-number-input';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import styles from './reservationCheck.module.css';
import { CircleSpinner } from 'react-spinners-kit';
import { convertTime12to24, getDatePerformance } from '../../../helpers/dates';

import Modal from '../../../components/Common/Modal/Modal';
import Button from '../../../components/Common/Button/Button';
import CustomerSpecialRequest from '../../../components/ReservationCheck/CustomerSpecialRequest/CustomerSpecialRequest';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import PaymentForm from '../../../components/PaymentForm/PaymentForm';
import ContentBottom from '../../../components/ContentBottom';
import PerformanceSelector from '../../../components/PerformanceSelector/PerformanceSelector';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import OccasionSelectorButton from '../../../components/ReservationCheck/OccasionSelectorButton/OccasionSelectorButton';

import SummaryProducts from '../../../components/ReservationCheck/Summary/SummaryProducts';
import Summary from '../../../components/ReservationCheck/Summary/Summary';
import DiscountSelector from '../../../components/DiscountSelector/DiscountSelector';

const ReservationCheckTickets = ({ history }) => {
  const { t } = useTranslation();
  const reservation = useSelector((state) => state.reservation);
  const associate = useSelector((state) => state.associates);
  const user = associate.user;
  const isCustomer = user?.roles?.includes('customer');
  const [loadingReservation, setLoadingReservation] = useState(true);
  const [loadingDiscount, setLoadingDiscount] = useState(false);
  const currency = useSelector((state) => state.currency.selected.shortForm);
  const idReservation = getQueryString('id');
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);
  const marketId = useSelector((state) => state.app.currentMarket.marketSetupId); //todo: borrar al implementar las ocaciones custom por cliente

  const [loadingEvent, setLoadingEvent] = useState(true);
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const [reservationInfo, setReservationInfo] = useState(null);
  const [originalReservation, setOriginalReservation] = useState(null);
  const [paxs, setPaxs] = useState(reservation.paxs);
  const hasProducts = reservation.products?.length > 0;
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [selectedButton, setSelectedButton] = useState(null);
  const [initialNoAvailabilityError, setInitialNoAvailabilityError] = useState(null);
  const [selectedPerformance, setSelectedPerformance] = useState(null);
  const [error, setError] = useState(null);
  const [phoneError, setPhoneError] = useState('');
  const [reservationDate, setReservationDate] = useState(null);
  const eventId = getQueryString('eventId');
  const [eventDetail, setEventDetail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingSchedule, setLoadingSchedule] = useState(true);
  const [intervals, setIntervals] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const showPerformanceSelector =
    reservationInfo?.reservationType === 'TICKET' ? false : eventDetail?.includeAvailability;
  const pickupId = getQueryString('pickupId');
  const handleSelectOccasion = (value) => {
    if (selectedButton === value) {
      setSelectedButton(null);
      handleChange(undefined, 'occasion', null);
    } else {
      handleChange(undefined, 'occasion', value);
      setSelectedButton(value);
    }
  };

  const getReservation = async (discount) => {
    if (discount) {
      setLoadingDiscount(true);
    }

    let reservationPreview = null;
    const pickupinfo = {
      ...reservation.transportation,
      id: pickupId,
    };

    const result = await fetchReservation({
      welletContext,
      reservation,
      language,
      refReservationId: idReservation,
      eventId,
      pickup: pickupId ? pickupinfo : null,
      discount,
    });

    if (result.success) {
      const data = result.data;
      reservationPreview = data;
      setReservationInfo(data);

      setReservationDate(new Date(reservation.date + 'T00:00:00'));
    } else {
      console.error(result.error);
    }
    setLoadingReservation(false);
    setLoadingDiscount(false);
    return reservationPreview;
  };

  const getOriginalReservation = async () => {
    //setLoading(true);
    try {
      const response = await welletContext.apis.tickets.get(
        `/Reservation/${idReservation}?lang=${language}`,
      );
      setOriginalReservation(response.data);
      setInitialValues(response.data);
      setPaxs(response.paxs);
      //setSelectedPerformance(format(new Date(response.data.reservationLocalDate), 'H:mm'));
    } catch (error) {
      console.error(error);
    } finally {
      //setLoading(false);
    }
  };

  const getSchedule = async () => {
    setLoadingSchedule(true);

    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/GetScheduleEvent?eventId=${eventId}&reservationType=AREA`,
      );

      if (result.data.schedules.length === 0) {
        setIntervals([]);
      }

      const formattedTimes = result.data.schedules.map((time) => {
        const time24 = new Date(reservation.date + 'T' + convertTime12to24(time.timeStart));

        if (time.timeMinutesStart >= 0 && time.timeMinutesStart <= 360)
          time24.setDate(time24.getDate() + 1);

        return { time24, soldOut: time.isSoldOut };
      });
      formattedTimes.sort();

      const allIntervals = formattedTimes.map(({ time24, soldOut }) => ({
        time: time24,
        soldOut,
      }));

      setIntervals(allIntervals);
      setLoadingSchedule(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getReservationAndSchedule = async () => {
    setLoadingSchedule(true);
    const reservation = await getReservation();
    if (reservation.isAvailable === false) {
      setInitialNoAvailabilityError(t('reservationError.NO_AVAILABILITY'));
    } else {
      getSchedule(reservation.availability);
    }
    setLoadingSchedule(false);
  };

  const getEventDetails = async () => {
    setLoadingEvent(true);
    try {
      const response = await welletContext.apis.tickets.get(
        `/shows/event/${eventId}?lang=${language}`,
      );
      setEventDetail(response.data);
    } catch (error) {
      console.error(error);
    }
    setLoadingEvent(false);
  };

  const setInitialValues = (reservation) => {
    handleChange(null, 'customerName', reservation.customerFirstName);
    handleChange(null, 'customerLastname', reservation.customerLastName);
    handleChange(null, 'phone', reservation.customerPhone);
  };

  useEffect(() => {
    handleChange(null, 'language', language);

    if (reservation.date && reservation.performance) {
      setReservationDate(new Date(reservation.date + 'T' + reservation.performance));
    }

    if (hasProducts) {
      getReservationAndSchedule();
    }
  }, []);

  const sendForm = async () => {
    if (reservationInfo.totalAmount === 0 && !isModalOpen) {
      setIsModalOpen(true);
      return;
    } else {
      setBtnStatus(ButtonStatus.InProgress);

      try {
        let url = '/reservation/GenerateReservation';

        if (reservationInfo && idReservation) {
          url = '/reservation/modifyreservation';
        }
        const reservationLocalTime = showPerformanceSelector
          ? getDatePerformance(reservation.date, selectedPerformance)
          : eventDetail.startDate;
        const pickupinfo = {
          ...reservation.transportation,
          id: pickupId,
        };
        const result = await welletContext.apis.tickets.put(url, {
          showId: reservation.showId,
          paxs: paxs,
          customer: {
            firstName: values.customerName,
            lastName: values.customerLastname,
            phone: values.phone,
            email: values.email,
          },
          comments: null,
          occasion: null,
          countryCode: values.countryCode ?? 'MX',
          reservationDateLocalTime: reservationLocalTime,
          totalAmount: reservationInfo?.totalAmount ?? null,
          products: reservation.products ?? null,
          oldReservationId: idReservation,
          eventId: eventId,
          language: null, //It shouldn't be sent, but the API sets it to "ES".
          pickup: pickupId ? pickupinfo : null,
          sellerDiscount: selectedDiscount,
        });

        setBtnStatus(ButtonStatus.ProgressFinished);
        setTimeout(() => {
          history.push(
            reservationInfo.totalAmount === 0
              ? '/reservation-success-courtesy'
              : `/reservation-success?reservationType=${result.data.reservationType}&status=${result.data.status}`,
          );
        }, 1500);
      } catch (error) {
        setBtnStatus(ButtonStatus.Error);
        let errorMessage;
        switch (error.response.data.errorType) {
          case 'GENERIC_ERROR':
            errorMessage = t('reservationError.GENERIC_ERROR');
            break;
          case 'SHOW_NOT_FOUND':
            errorMessage = t('reservationError.SHOW_NOT_FOUND');
            break;
          case 'SCHEDULE_SOLD_OUT':
            errorMessage = t('reservationError.SCHEDULE_SOLD_OUT');
            break;
          case 'INVALID_RESERVATION_DATE':
            errorMessage = t('reservationError.INVALID_RESERVATION_DATE');
            break;
          case 'NO_AVAILABILITY':
            errorMessage = t('reservationError.NO_AVAILABILITY');
            break;
          case 'DUPLICATE_RESERVATION':
            errorMessage = t('reservationError.DUPLICATE_RESERVATION');
            break;
          case 'SALES_EVENT_END':
            errorMessage = t('reservationError.NO_AVAILABILITY');
            break;
          default:
            errorMessage = t('reservationError.GENERIC_ERROR');
        }
        setError(errorMessage);
      }
    }
  };

  const handleConfirmAction = () => {
    setIsModalOpen(false);
    sendForm();
  };

  const handleDiscountChange = (discount) => {
    setSelectedDiscount(discount);
    getReservation(discount);
  };

  function validate(values) {
    let errors = {};

    if (!originalReservation) {
      //todo: cambiar la respuesta de la reserva original desde la api. Tiene que retornar el objeto customer
      if (!values.customerName) {
        errors.customerName = t('nameError.EMPTY_NAME');
      } else if (/\d/.test(values.customerName)) {
        errors.customerName = t('nameError.NOT_NUMBERS');
      }

      if (!values.email) {
        errors.email = t('emailError.EMPTY_EMAIL');
      } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = t('emailError.INVALID_EMAIL');
      }

      if (!values.customerLastname) {
        errors.customerLastname = t('nameError.EMPTY_LASTNAME');
      } else if (/\d/.test(values.customerLastname)) {
        errors.customerLastname = t('nameError.NOT_NUMBERS');
      }

      if (!values.phone) {
        errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
        setPhoneError(errors.phone);
      } else {
        setPhoneError('');
      }

      if (values.phone && !isValidPhoneNumber(values.phone)) {
        errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
        setPhoneError(errors.phone);
      }
    }

    if (showPerformanceSelector && !selectedPerformance) {
      errors.performance = t('selectArrivalTime');
    }

    return errors;
  }

  useEffect(() => {
    getEventDetails();

    if (idReservation) getOriginalReservation();
  }, []);

  let { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <>
      {loadingEvent || loadingReservation ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header />
          <ContentApp classes='pb-0'>
            {initialNoAvailabilityError ? (
              <>
                <ErrorBox title={initialNoAvailabilityError} />
                <div className='mt-4 text-center text-primary' onClick={() => history.goBack()}>
                  {t('reschedule')}
                </div>
              </>
            ) : (
              <>
                <EventHeader
                  eventImg={eventDetail.bannerImage}
                  eventName={eventDetail.name}
                  eventDescription={eventDetail.show.name}
                  eventDate={eventDetail.startDate}
                  eventEndDate={eventDetail.endDate}
                />

                <>
                  <div
                    className={`${
                      reservationInfo.consumptionAmount > 0 ? 'border-none pb-0' : ''
                    } ${styles.paymentSection}`}
                  >
                    <SummaryProducts reservationInfo={reservationInfo} />
                    {reservationInfo.consumptionAmount > 0 && (
                      <div className={`${styles.consumption} text-center mt-4`}>
                        {t('consumptionIncluded', {
                          consumption: '$' + reservationInfo?.consumptionAmount,
                        })}
                      </div>
                    )}
                  </div>
                  {reservationInfo.discountOptions &&
                    reservationInfo.discountOptions.length > 0 && (
                      <DiscountSelector
                        discountOptions={reservationInfo.discountOptions}
                        onDiscountChange={handleDiscountChange}
                        discountApplied={reservationInfo.totalDiscount < 0}
                        disabled={loadingDiscount}
                      />
                    )}
                  {reservationInfo.products.some((x) => !x.isCourtesy) && (
                    <div
                      className={
                        `border-none mt-3 position-relative ${
                          loadingDiscount ? styles.disabled : ''
                        } ` + styles.paymentSection
                      }
                    >
                      {loadingDiscount && (
                        <div className='loading-content'>
                          <CircleSpinner
                            className='spinner-app mx-auto'
                            style={{ margin: 'auto' }}
                            size={40}
                            color='var(--color-font-primary)'
                          />
                        </div>
                      )}
                      <Summary reservation={reservationInfo} />
                    </div>
                  )}
                </>

                {/* <ReservationInfo
                  reservationInfo={reservationInfo}
                  t={t}
                  hasProducts={hasProducts}
                /> */}
                {!isCustomer && (
                  <Fragment>
                    {originalReservation?.customerName ? (
                      <>
                        <span className='fw-semibold text-primary font-tiny'>
                          {t('reservationInformation')}
                        </span>
                        <div className='mt-2 text-secondary text-small'>{t('bookingHolder')}</div>
                        <span className='font-medium fw-semibold mt-1 '>
                          {originalReservation?.customerName}
                        </span>
                        {originalReservation?.reservationOccasion && (
                          <>
                            <div className='mt-3 text-secondary text-small'>
                              {t('bookingHolder')}
                            </div>
                            <span className='text-tertiary fw-semibold mt-1'>
                              {originalReservation?.reservationOccasion}
                            </span>
                          </>
                        )}
                        {originalReservation?.reservationComments && (
                          <>
                            <div className='mt-3 text-secondary text-small'>
                              {t('specialRequest')}
                            </div>
                            <span className='text-tertiary fw-semibold mt-1'>
                              {originalReservation?.reservationComments}
                            </span>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className='fw-semibold text-primary font-tiny mb-3'>
                          {t('reservationInformation')}
                        </div>
                        <ReservationCheckCustomerInfo
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          phoneError={phoneError}
                          setPhoneError={setPhoneError}
                          countryCode={countryCode}
                        />

                        {reservationInfo?.reservationType !== 'TICKET' && marketId !== 581 && (
                          <div className='mt-4'>
                            <OccasionSelectorButton
                              handleSelectButton={handleSelectOccasion}
                              selectedButton={selectedButton}
                            />
                          </div>
                        )}
                        {reservationInfo?.reservationType !== 'TICKET' && (
                          <div className='mt-4'>
                            <CustomerSpecialRequest values={values} handleChange={handleChange} />
                          </div>
                        )}
                      </>
                    )}

                    {showPerformanceSelector && (
                      <>
                        <div className='fw-semibold text-primary font-tiny mt-3'>
                          {t('arrivalTime')}
                        </div>

                        {intervals.length ? (
                          <>
                            <div className='mt-3 mb-3'>
                              <PerformanceSelector
                                performances={intervals}
                                onHandleChange={setSelectedPerformance}
                                defaultPerformance={selectedPerformance}
                              />
                            </div>
                            {errors.performance && (
                              <div
                                className='errorLabel mt-2 position-relative error-label'
                                style={{ color: '#fff' }}
                              >
                                <span></span> {errors.performance}
                              </div>
                            )}
                          </>
                        ) : (
                          <div className='mt-3'>
                            <EmptyActivity title={t('noSchedule')} />
                          </div>
                        )}
                      </>
                    )}

                    {error && (
                      <div className='mt-4'>
                        <>
                          <ErrorBox title={error} />
                          <div
                            className='mt-4 text-center text-primary'
                            onClick={() => history.goBack()}
                          >
                            {t('reschedule')}
                          </div>
                        </>
                      </div>
                    )}
                  </Fragment>
                )}

                {/* {hasProducts && reservationInfo.remainingDepositAmount > 0 && (
              <div className='font-1rem mt-3'>
                <div className='bold font-smaller text-primary'>{t('reservationCondition')}</div>
                <div className='mt-1'>
                  <span className='bold'>{t('paymentRequiredTitle')}</span>{' '}
                  {t('paymentRequiredText')}{' '}
                  <Money
                    value={reservationInfo.remainingDepositAmount}
                    symbol={currency.shortForm}
                    lowDecimals={true}
                    decimal={false}
                  />
                </div>

                <div className='font-small fw-semibold mt-2'></div>
              </div>
            )} */}
                {isModalOpen && (
                  <Modal
                    title={t('confirmAction')}
                    onClose={() => setIsModalOpen(false)}
                    hasBackground
                  >
                    <div className='text-white text-center fw-semibold'>
                      {t('courtesyTicketsMessage', {
                        currency,
                      })}
                    </div>
                    <Button
                      size='medium'
                      status={ButtonStatus.Normal}
                      text={t('confirm')}
                      onClick={handleConfirmAction}
                      className='mt-4'
                    />
                    <Button
                      size='medium'
                      status={ButtonStatus.Normal}
                      text={t('cancel')}
                      onClick={() => setIsModalOpen(false)}
                      className=' mt-2'
                      backgroundColor='#fff'
                      color='#000'
                    />
                  </Modal>
                )}
              </>
            )}
          </ContentApp>
          {!isCustomer && (
            <ContentBottom>
              <div className='mt-4'>
                <ButtonProccessing
                  status={btnStatus}
                  text={reservationInfo.totalAmount === 0 ? t('generateTickets') : t('sendPaymentLink')}
                  size='large'
                  className={styles.btn}
                  type='submit'
                  onClick={handleSubmit}
                  arrow
                  color='#000'
                  backgroundColor='var(--color-primary)'
                  iconColor='#000'
                />
              </div>
            </ContentBottom>
          )}

          {isCustomer && reservationInfo && (
            <div className='content-botton p-0'>
              <PaymentForm reservation={reservationInfo} products={reservation.products} />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ReservationCheckTickets;
